<template>
  <CardTitleContent title="Sync Services Status" :startOpen="true">
    <template #header-controls>
      <div
        @click="toDetails"
        style="cursor: pointer;"
        class="d-flex align-items-center"
      >
        <span class="label label-primary" style="color: black; margin-right: 8px;">
          Ir para detalhes <i class="fa fa-arrow-right" aria-hidden="true"></i>
        </span>
      </div>

      <span class="label label-danger">
        {{ syncServices.length }} alerta{{ syncServices.length > 1 ? "s" : ""}}
      </span>
    </template>


    <div
      class="alert alert-danger d-flex justify-content-between align-items-center"
      v-for="syncService in syncServices"
      :key="syncService.id"
    >
      {{ syncService.chave_servico }}
    </div>
  </CardTitleContent>
</template>

<script>
import CardTitleContent from "@/components/shared/CardTitleContent.vue";

export default {
  name: "SyncAlerts",

  components: {
    CardTitleContent,
  },

  props: {
    syncServices: {
      type: Array,
      required: true,
      default: () => [],
    },
  },

  methods: {
    toDetails() {
      this.$emit("toDetails");
    },
  },
};
</script>
